import {
  CLEAR_ADJUST_PRODUCT, GET_ADJUST_PRODUCT, GET_INVENTORY, GET_PRODUCT_ORDER, GET_PRODUCTS,
} from '../actions/products';

const initialState = {
  requestStatus: '',
  requestStatusAdjust: '',
  productList: [],
  productTotalPage: 1,
  inventoryList: [],
  inventoryTotalPage: 1,
  adjustProduct: [],
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_PRODUCTS.SUCCESS: {
      return {
        ...state,
        productList: payload.data.data.response,
        productTotalPage: payload.data.data._meta.pageCount,
      };
    }

    case GET_INVENTORY.REQUEST: {
      return {
        ...state,
        requestStatus: 'request',
      };
    }

    case GET_INVENTORY.SUCCESS: {
      return {
        ...state,
        requestStatus: 'success',
        inventoryList: payload.data.response,
        inventoryTotalPage: payload.data._meta.pageCount,
      };
    }

    case GET_INVENTORY.FAIL: {
      return {
        ...state,
        requestStatus: 'fail',
      };
    }

    case GET_ADJUST_PRODUCT.REQUEST:
    case GET_PRODUCT_ORDER.REQUEST: {
      return {
        ...state,
        requestStatusAdjust: 'request',
      };
    }

    case GET_ADJUST_PRODUCT.SUCCESS:
    case GET_PRODUCT_ORDER.SUCCESS: {
      return {
        state,
        requestStatusAdjust: 'success',
        adjustProduct: payload.data.response,
      };
    }

    case CLEAR_ADJUST_PRODUCT: {
      return {
        ...state,
        adjustProduct: [],
      };
    }

    default:
      return state;
  }
};

export default reducer;
